// frontend/packages/business-console/src/services/crmService.js
//
// Thin wrapper over /api/v2/crm/*. Business context is supplied via the
// x-business-id header (axios interceptor in @upryzze/services); callers
// don't pass businessId.

import { api } from "@upryzze/services";

/**
 * GET /api/v2/crm/customers
 * @param {object} params
 *   stage, q, before (ISO date), limit
 *   acrossMyBusinesses (boolean) — true to query across all businesses the
 *     user has CRM-grade access to.
 *   inCrm (boolean) — defaults to true on the server.
 */
export async function listCustomers(params = {}) {
  const { data } = await api.get("/v2/crm/customers", { params });
  return data || { items: [], hasMore: false, nextCursor: null };
}

export async function createCustomer(payload) {
  const { data } = await api.post("/v2/crm/customers", payload);
  return data;
}

export async function getCustomer(id) {
  if (!id) throw new Error("Customer id is required");
  const { data } = await api.get(`/v2/crm/customers/${encodeURIComponent(id)}`);
  return data;
}

export async function updateCustomer(id, updates) {
  if (!id) throw new Error("Customer id is required");
  const { data } = await api.patch(
    `/v2/crm/customers/${encodeURIComponent(id)}`,
    updates,
  );
  return data;
}

export async function listActivity(id, params = {}) {
  if (!id) throw new Error("Customer id is required");
  const { data } = await api.get(
    `/v2/crm/customers/${encodeURIComponent(id)}/activity`,
    { params },
  );
  return data || { items: [], hasMore: false, nextCursor: null };
}

/**
 * POST a new activity. Only `note_added` and `manual_log` kinds are accepted.
 * Body: { kind, body, meta? }
 */
export async function createActivity(id, body) {
  if (!id) throw new Error("Customer id is required");
  if (!body?.body || !String(body.body).trim()) {
    throw new Error("Activity body is required");
  }
  const { data } = await api.post(
    `/v2/crm/customers/${encodeURIComponent(id)}/activity`,
    body,
  );
  return data;
}

export async function getLinkSuggestions(id) {
  if (!id) throw new Error("Customer id is required");
  const { data } = await api.get(
    `/v2/crm/customers/${encodeURIComponent(id)}/link-suggestions`,
  );
  return data?.items || [];
}

export async function linkPerson(id, { customerIds, displayName } = {}) {
  if (!id) throw new Error("Customer id is required");
  const { data } = await api.post(
    `/v2/crm/customers/${encodeURIComponent(id)}/link-person`,
    { customerIds, displayName },
  );
  return data;
}

export async function unlinkPerson(id) {
  if (!id) throw new Error("Customer id is required");
  const { data } = await api.delete(
    `/v2/crm/customers/${encodeURIComponent(id)}/link-person`,
  );
  return data;
}
